module.exports = __webpack_public_path__ + "861f262ada0e4eb76b72fd5cc0554648.svg";